import {
    registerDecorator,
    ValidationArguments,
    ValidationOptions,
    ValidatorConstraint,
    ValidatorConstraintInterface
} from "class-validator";
import { FileUploadDto } from "../../../shared/src";
import { getBase64FileSize } from "../utils/getBase64FileSize";
import { isArray } from 'lodash-es';

@ValidatorConstraint({ name: 'MaxBase64FileSize', async: true })
export class MaxBase64FileSizeValidator implements ValidatorConstraintInterface {
    async validate(value: FileUploadDto | FileUploadDto[], validationArguments: ValidationArguments) {
        try {
            if (!value) return true;

						const filesToValidate = isArray(value)
							? value as FileUploadDto[]
							: [value as FileUploadDto];

						for (const fileToValidate of filesToValidate) {
							if (!fileToValidate.base64EncodedFile) return true;
							const fileSize = getBase64FileSize(fileToValidate.base64EncodedFile);

							if (!fileSize) return false;
							const { constraints: [ maxSizeInMegabytes ] } = validationArguments;

							if (fileSize > maxSizeInMegabytes * 10 ** 6) return false;
						}
        } catch (e) {
            return false;
        }

        return true;
    }

    defaultMessage(args: ValidationArguments) {
        return `File size is too large or file doesn't have a "base64EncodedFile" required field`;
    }
}

export const MaxBase64FileSize = (maxSizeInMegabytes: number, validationOptions?: ValidationOptions) => (object: Record<never, never>, propertyName: string): void => {
    registerDecorator({
        name: 'MaxBase64FileSize',
        target: object.constructor,
        propertyName,
        options: validationOptions,
        validator: MaxBase64FileSizeValidator,
        constraints: [ maxSizeInMegabytes ],
    });
};
